import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

// Resolved here, before the router checks the first route: saved choice, then
// browser language, then the default. (LocaleButton keeps saving the choice.)
function initialLocale () {
  const supported = l => l === 'de' || l === 'en'
  try {
    const saved = window.localStorage.getItem('locale')
    if (supported(saved)) return saved
  } catch (e) { /* storage blocked */ }
  const first = window.navigator.languages && window.navigator.languages[0]
  const browser = first && first.split('-')[0]
  if (supported(browser)) return browser
  return process.env.VUE_APP_I18N_LOCALE || 'en'
}

export default new VueI18n({
  locale: initialLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
